export function addDocuments (manager, documentsArray, language) {
    Object.keys(documentsArray).forEach((intent) => {
        documentsArray[intent].forEach((document) => {
            manager.addDocument(language, document, intent)
        })
    })
}

export function addAnswers (manager, answersArray, language) {
    Object.keys(answersArray).forEach((intent) => {
        answersArray[intent].forEach((answer) => {
            manager.addAnswer(language, intent, answer)
        })
    })
}
